import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { computed, defineComponent, nextTick, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import { useApplicationStepMachine } from "@Client/@Composables/application-standalone/machine/useApplicationStepMachine";
import GoalsPage from "@Client/@Modules/application-standalone/components/pages/goals-page.vue";
import SubjectPropertyPage from "@Client/@Modules/application-standalone/components/pages/subject-property-page.vue";
import ApplicantsPage from "@Client/@Modules/application-standalone/components/pages/applicants-page.vue";
import IdentificationsPage from "@Client/@Modules/application-standalone/components/pages/identifications-page.vue";
import IncomeHistoryPage from "@Client/@Modules/application-standalone/components/pages/income-history-page.vue";
import AssetsPage from "@Client/@Modules/application-standalone/components/pages/assets-page.vue";
import LiabilitiesPage from "@Client/@Modules/application-standalone/components/pages/liabilities-page.vue";
import OtherPropertiesPage from "@Client/@Modules/application-standalone/components/pages/other-properties-page.vue";
import SummaryPage from "@Client/@Modules/application-standalone/components/pages/summary-page.vue";
import ApplicationSubmitted from "@Client/@Modules/deprecated-application/components/application-submitted.vue";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import * as ApplicationStandAloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import { useApplicationStandaloneStoreActions, useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import NavigationToolbar from "@Client/@Modules/application-standalone/components/helpers/navigation-toolbar.vue";
import ApplicationStandaloneLoader from "@Client/@Modules/application-standalone/components/loaders/application-standalone-loader.vue";
import Err from "@Client/@Routes/error";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useAccountStoreGetters } from "@Client/@Modules/main/store/account/account-helpers";
import { useAccountStoreActions } from "@Client/@Modules/main/store/account/account-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useApplicationVisibilityState } from "@Client/@Composables/application-standalone/machine/useApplicationVisibilityState";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import useVuelidate from "@vuelidate/core";
export default defineComponent({
  name: "ApplicationStandalone",
  components: {
    GoalsPage,
    SubjectPropertyPage,
    ApplicantsPage,
    IdentificationsPage,
    IncomeHistoryPage,
    AssetsPage,
    LiabilitiesPage,
    OtherPropertiesPage,
    SummaryPage,
    NavigationToolbar,
    ApplicationSubmitted,
    ApplicationStandaloneLoader
  },
  props: {
    applicationId: {
      type: String,
      required: true
    },
    currentStep: {
      type: String,
      default: null
    },
    isFillOut: {
      type: Boolean,
      default: false
    },
    invalidSteps: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {
    emit
  }) {
    const {
      applicationId,
      isFillOut
    } = toRefs(props);
    const saving = ref(false);
    const submitting = ref(false);
    const applicationSubmittedModal = ref();
    const showInformationPage = ref(false);
    const showErrors = ref(0);
    const areInvalidsItemsOnSummary = ref(false);
    const brokerageId = ref("");
    const hasRequestedDocuments = ref(false);
    const {
      GET_AGENT_DETAILS_BY_SUBDOMAIN
    } = useAccountStoreGetters([AccountGetters.GET_AGENT_DETAILS_BY_SUBDOMAIN, AccountGetters.GET_ACCOUNT_AGENTS]);
    const {
      LOAD_AGENT_DETAILS_WITH_SUBDOMAIN
    } = useAccountStoreActions([AccountActions.LOAD_AGENT_DETAILS_WITH_SUBDOMAIN]);
    const {
      LOAD_CUSTOMIZATION_SCHEMA,
      LOAD_APPLICATION_DATA,
      LOAD_DISCLAIMERS,
      UPDATE_APPLICATION,
      SUBMIT_APPLICATION
    } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.LOAD_CUSTOMIZATION_SCHEMA, ApplicationStandAloneActions.LOAD_APPLICATION_DATA, ApplicationStandAloneActions.LOAD_DISCLAIMERS, ApplicationStandAloneActions.UPDATE_APPLICATION, ApplicationStandAloneActions.SUBMIT_APPLICATION]);
    const {
      SET_CURRENT_APPLICATION_ID,
      SET_APPLICATION_FLOW,
      CLEAR_ALL_SINS,
      SET_IS_FILL_OUT,
      SET_LOADING,
      SET_CURRENT_APPLICATION_CHANGES
    } = useApplicationStandaloneStoreMutations([ApplicationStandAloneMutations.SET_CURRENT_APPLICATION_ID, ApplicationStandAloneMutations.SET_APPLICATION_FLOW, ApplicationStandAloneMutations.CLEAR_ALL_SINS, ApplicationStandAloneMutations.SET_IS_FILL_OUT, ApplicationStandAloneMutations.SET_LOADING, ApplicationStandAloneMutations.SET_CURRENT_APPLICATION_CHANGES]);
    const appComponentMap = ref({
      [APPLICATION_STEPS.GOALS]: "GoalsPage",
      [APPLICATION_STEPS.SUBJECT_PROPERTY]: "SubjectPropertyPage",
      [APPLICATION_STEPS.APPLICANTS]: "ApplicantsPage",
      [APPLICATION_STEPS.IDENTIFICATIONS]: "IdentificationsPage",
      [APPLICATION_STEPS.INCOME_HISTORY]: "IncomeHistoryPage",
      [APPLICATION_STEPS.ASSETS]: "AssetsPage",
      [APPLICATION_STEPS.LIABILITIES]: "LiabilitiesPage",
      [APPLICATION_STEPS.OTHER_PROPERTIES]: "OtherPropertiesPage",
      [APPLICATION_STEPS.SUBMIT]: "SummaryPage"
    });
    const stepsWithSins = ref([APPLICATION_STEPS.APPLICANTS]);
    const {
      machineInstance,
      currentStep
    } = useApplicationStepMachine();
    const state = computed(() => {
      var _machineInstance$valu;
      return (_machineInstance$valu = machineInstance.value) == null ? void 0 : _machineInstance$valu.state;
    });
    const appComponent = computed(() => appComponentMap.value[currentStep.value]);
    const handleChangeFlow = newFlow => {
      SET_APPLICATION_FLOW({
        flow: newFlow
      });
    };
    const isGoalsPage = computed(() => currentStep.value === APPLICATION_STEPS.GOALS);
    const isSubjectPropertyPage = computed(() => currentStep.value === APPLICATION_STEPS.SUBJECT_PROPERTY);
    const isSummaryPage = computed(() => !isSubmitPage.value && !showInformationPage.value);
    const canGoNext = computed(() => {
      var _state$value;
      return !saveButtonDisabled.value && (state == null ? void 0 : (_state$value = state.value) == null ? void 0 : _state$value.can("NEXT"));
    });
    const canGoPrev = computed(() => {
      var _state$value2;
      return state == null ? void 0 : (_state$value2 = state.value) == null ? void 0 : _state$value2.can("PREV");
    });
    const isSubmitPage = computed(() => currentStep.value === APPLICATION_STEPS.SUBMIT);
    const canSubmit = computed(() => {
      return !saveButtonDisabled.value && isSubmitPage.value;
    });
    const goNext = async () => {
      var _machineInstance$valu2;
      await validateSteps(currentStep.value);
      machineInstance == null ? void 0 : (_machineInstance$valu2 = machineInstance.value) == null ? void 0 : _machineInstance$valu2.send("NEXT");
    };
    const goPrev = async () => {
      var _machineInstance$valu3;
      await validateSteps(currentStep.value);
      machineInstance == null ? void 0 : (_machineInstance$valu3 = machineInstance.value) == null ? void 0 : _machineInstance$valu3.send("PREV");
    };
    const goEdit = async (page, shouldValidate = true) => {
      var _machineInstance$valu4;
      if (shouldValidate) await validateSteps(page);
      machineInstance == null ? void 0 : (_machineInstance$valu4 = machineInstance.value) == null ? void 0 : _machineInstance$valu4.send(page);
    };
    const validateSteps = async currentPage => {
      const invalidPages = [];
      for (const page of visiblePages.value) {
        if (page === currentPage) break;
        if (!(await stepsValidations[page]())) {
          invalidPages.push(page);
        }
      }
      emit("invalid-step", {
        invalidPages
      });
    };
    const updateApplication = async () => {
      try {
        var _context, _state$value3;
        saving.value = true;
        await UPDATE_APPLICATION({
          newBrokerageId: brokerageId.value
        });
        if (_includesInstanceProperty(_context = stepsWithSins.value).call(_context, (_state$value3 = state.value) == null ? void 0 : _state$value3.value)) {
          CLEAR_ALL_SINS();
        }
        saving.value = false;
      } catch (e) {
        Err.handle(e);
      }
    };
    const {
      LOADING,
      APPLICATION_IS_LOCKED,
      APPLICATION_HAS_REQUESTED_DOCUMENTS
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.LOADING, ApplicationStandaloneGetters.APPLICATION_IS_LOCKED, ApplicationStandaloneGetters.APPLICATION_HAS_REQUESTED_DOCUMENTS]);
    const submitApplication = async () => {
      if (submitting.value) return;
      submitting.value = true;
      try {
        await SUBMIT_APPLICATION({
          newBrokerageId: brokerageId.value
        });
        if (APPLICATION_HAS_REQUESTED_DOCUMENTS.value) {
          hasRequestedDocuments.value = true;
        }
        applicationSubmittedModal.value.$refs.modal.show();
      } catch (e) {
        Err.handle(e);
      } finally {
        submitting.value = false;
      }
    };
    const {
      allApplicants,
      allOtherPropertiesExistingMortgage
    } = useApplicantHelpers();
    const {
      visibilityState
    } = useApplicationVisibilityState();
    const visiblePages = computed(() => {
      var _context2;
      return _mapInstanceProperty(_context2 = visibilityState.value).call(_context2, ({
        name
      }) => name);
    });
    const {
      stepsValidations
    } = useValidatorsHelper();
    onMounted(async () => {
      var _GET_AGENT_DETAILS_BY;
      await LOAD_AGENT_DETAILS_WITH_SUBDOMAIN();
      SET_IS_FILL_OUT({
        isFillOut: isFillOut.value
      });
      SET_CURRENT_APPLICATION_ID({
        applicationId: applicationId.value
      });
      brokerageId.value = GET_AGENT_DETAILS_BY_SUBDOMAIN == null ? void 0 : (_GET_AGENT_DETAILS_BY = GET_AGENT_DETAILS_BY_SUBDOMAIN.value.agentDetails) == null ? void 0 : _GET_AGENT_DETAILS_BY.brokerage_id;
      SET_LOADING(true);
      SET_CURRENT_APPLICATION_CHANGES({});
      await LOAD_APPLICATION_DATA({
        newBrokerageId: brokerageId == null ? void 0 : brokerageId.value
      });
      await LOAD_CUSTOMIZATION_SCHEMA({});
      await LOAD_DISCLAIMERS();
      await nextTick();
      for (const page of visiblePages.value) {
        if (page !== APPLICATION_STEPS.SUBMIT && !(await stepsValidations[page]())) {
          emit("invalid-step", {
            invalidPages: [page]
          });
          goEdit(page, false);
          break;
        }
      }
      if (!currentStep.value || currentStep.value === APPLICATION_STEPS.SUBMIT) {
        emit("update:currentStep", APPLICATION_STEPS.SUBMIT);
        goEdit(APPLICATION_STEPS.SUBMIT);
      }
      SET_LOADING(false);
    });
    const handleSave = async navigationSlotBinds => {
      var _navigationSlotBinds$;
      const goNextFunction = (_navigationSlotBinds$ = navigationSlotBinds == null ? void 0 : navigationSlotBinds.handleNavigateNext) != null ? _navigationSlotBinds$ : goNext;
      if (!APPLICATION_IS_LOCKED.value) {
        if (canSubmit.value) return submitApplication();
        await updateApplication();
      }
      goNextFunction();
    };
    const handleBack = async navigationSlotBinds => {
      var _navigationSlotBinds$2;
      const goBackFunction = (_navigationSlotBinds$2 = navigationSlotBinds == null ? void 0 : navigationSlotBinds.handleNavigateBack) != null ? _navigationSlotBinds$2 : goPrev;
      if (!APPLICATION_IS_LOCKED.value) await updateApplication();
      goBackFunction();
    };
    const disableSave = disable => {
      areInvalidsItemsOnSummary.value = disable;
    };
    watch(currentStep, value => emit("update:currentStep", value));
    const handleShowErrors = value => {
      if (value === 0) {
        return showErrors.value = 0;
      }
      showErrors.value++;
    };
    const v = useVuelidate();
    const saveButtonDisabled = computed(() => (isSummaryPage.value || isSubmitPage.value) && areInvalidsItemsOnSummary.value || v.value.$invalid);
    return {
      state,
      goNext,
      goPrev,
      goEdit,
      appComponent,
      handleChangeFlow,
      canGoNext,
      canGoPrev,
      canSubmit,
      handleSave,
      handleBack,
      LOADING,
      saving,
      brokerageId,
      submitting,
      updateApplication,
      submitApplication,
      applicationSubmittedModal,
      allOtherPropertiesExistingMortgage,
      saveButtonDisabled,
      isSubmitPage,
      isSubjectPropertyPage,
      isGoalsPage,
      isSummaryPage,
      allApplicants,
      disableSave,
      validateSteps,
      APPLICATION_IS_LOCKED,
      showInformationPage,
      showErrors,
      handleShowErrors,
      v,
      areInvalidsItemsOnSummary,
      UPDATE_APPLICATION,
      hasRequestedDocuments
    };
  }
});